
import React from 'react';
import Layout from '@/components/Layout/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import BulkPhotoUploader from '@/components/PhotoUploader/BulkPhotoUploader';

const Dashboard = () => {
  return (
    <Layout>
      <div className="container py-8 space-y-8">
        <div>
          <h1 className="text-4xl font-bold mb-2">Blog Page Builder</h1>
          <p className="text-lg text-muted-foreground">
            Create SEO-optimized blog content using dynamic variables
          </p>
        </div>

        {/* Bulk Photo Uploader */}
        <div className="mb-8">
          <BulkPhotoUploader />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Specialty Services</CardTitle>
              <CardDescription>View specialty service pages</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Browse and manage specialty service pages targeting specific customer needs
                like Church Steeple Repair and Roof Coating services.
              </p>
              <div className="space-y-2">
                <Button asChild className="w-full">
                  <Link to="/specialty-services/church-steeple-repair">View Church Steeple Service</Link>
                </Button>
                <Button asChild variant="outline" className="w-full">
                  <Link to="/specialty-services/roof-coating">View Roof Coating Service</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Location Pages</CardTitle>
              <CardDescription>Manage location-specific pages</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Access and manage location-specific pages for different service areas in Eastern NC
                with customized content for each market.
              </p>
              <div className="space-y-2">
                <Button asChild className="w-full">
                  <Link to="/locations/wilson">Wilson Location Page</Link>
                </Button>
                <Button asChild variant="outline" className="w-full">
                  <Link to="/locations">All Locations</Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Variables</CardTitle>
              <CardDescription>Manage your dynamic content variables</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Create and manage reusable content variables that can be inserted into your blog templates
                for dynamic content generation.
              </p>
              <Button asChild className="w-full">
                <Link to="/variables">Manage Variables</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Photo Album</CardTitle>
              <CardDescription>Admin photo management</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Upload, edit, delete, and manage all photos with metadata. Full admin control
                over the image gallery and variables.
              </p>
              <Button asChild className="w-full">
                <Link to="/photo-album/">Manage Photo Album</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Photo Gallery</CardTitle>
              <CardDescription>Public photo display</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                View the public-facing photo gallery as visitors see it.
                Browse and search through published images.
              </p>
              <Button asChild className="w-full" variant="outline">
                <Link to="/gallery">View Public Gallery</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Blog Posts</CardTitle>
              <CardDescription>Manage your published content</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                View, edit, and manage all your blog posts. Export content or publish directly
                to your website.
              </p>
              <Button asChild className="w-full">
                <Link to="/posts">Manage Posts</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>SEO Audit</CardTitle>
              <CardDescription>Monitor your website's SEO performance</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Comprehensive SEO analysis including meta tags, schema markup, 
                performance metrics, and indexing status across all pages.
              </p>
              <Button asChild className="w-full">
                <Link to="/seo-audit">View SEO Audit</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Link Checker</CardTitle>
              <CardDescription>Find and fix broken links across your site</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Crawl your entire website to identify broken links, redirects, and 
                other link-related issues that could impact SEO and user experience.
              </p>
              <Button asChild className="w-full">
                <Link to="/link-checker">Run Link Check</Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
